import React from 'react';
import { Collapsed } from './components/Collapsed';
import { useVideoPlayerContext } from './context';

interface VideoPlayerCollapsedProps {
	onExpand?: () => void;
	onResize?: () => void;
}

export function VideoPlayerCollapsed({
	onExpand,
	onResize
}: Readonly<VideoPlayerCollapsedProps>): JSX.Element | JSX.Element[] {
	const { handleExpandCollapsed } = useVideoPlayerContext();

	function handleExpand(): void {
		handleExpandCollapsed();
		onExpand?.();
	}

	return <Collapsed onExpand={handleExpand} onResize={onResize} />;
}
